// Application constants and feature flags

// Feature flags for asset loading
export const USE_LOCAL_ASSETS = true;
export const ENABLE_IMAGE_PRELOADING = false;
export const ENABLE_DECK_DOWNLOADS = false;

// Asset paths
export const LOCAL_ASSETS_BASE_PATH = '/assets/decks';

// Default fallback deck
export const DEFAULT_DECK_NAME = 'default';

// API configuration
export const API_BASE_URL = import.meta.env.VITE_SERVER_URL || '';

// Cache configuration
export const IMAGE_CACHE_MAX_SIZE = 100;
export const PRELOAD_BATCH_SIZE = 5;
